import * as yup from 'yup';

export const getChooseRegisterSchema = yup.object().shape({
  userType: yup.string().required('Veuillez sélectionner une proposition.'),
});
